
import IReduxState from "../../store/IState";


export const selectHavainnotState = (state: IReduxState) => state.havainnot;
